import { useCallback, useRef, useState, useEffect } from 'react';
import API from '../utils/api';

export default function useViolationReporter({
  endpoint,
  idField,
  idValue,     
  active,
  disqualified,
  maxViolations,
  webcamRef,
  onDisqualified,
  onViolation,
}) {
  const [violationCount, setViolationCount] = useState(0);
  const lockRef = useRef(false);
  const idValueRef = useRef(idValue); 
  const activeRef = useRef(active);
const disqualifiedRef = useRef(disqualified);

useEffect(() => { activeRef.current = active; }, [active]);
useEffect(() => { disqualifiedRef.current = disqualified; }, [disqualified]);


  useEffect(() => {
    idValueRef.current = idValue;
  }, [idValue]);

const registerViolation = useCallback(async (violationType, message) => {
    if (!activeRef.current || disqualifiedRef.current || lockRef.current) return;
    const currentIdValue = idValueRef.current;
    if (!currentIdValue) return;

    lockRef.current = true;

    let screenshot = null;
    try { screenshot = webcamRef.current?.getScreenshot?.() || null; } catch (e) {}

    try {
      const res = await API.post(endpoint, {
        [idField]: currentIdValue,
        violation_type: violationType || 'rule_violation',
        description: message,
        screenshot,
      });
      const nextCount = Number(res.data?.violation_count || 0);
      setViolationCount(nextCount);

      onViolation?.({
        type: violationType,
        message,
        count: nextCount,
        disqualified: !!res.data?.disqualified,
      });

      if (res.data?.disqualified) onDisqualified?.();
    } catch (err) {
      console.error('Register violation error:', err);
      setViolationCount((prev) => {
        const next = prev + 1;
        if (next >= maxViolations) onDisqualified?.();
        return next;
      });
    }

    setTimeout(() => { lockRef.current = false; }, 1800);
  }, [endpoint, idField, maxViolations, webcamRef, onDisqualified, onViolation]);

  return { violationCount, setViolationCount, registerViolation };
}